<template>
  <Carousel v-bind="settings">
    <Slide v-for="post in posts" :key="post.id">
      <div class="card pb-4">
        <div class="img-box">
          <NuxtLink :to="{name: 'language-modelos-name-making-of', params: {name: post.slug}}">
            <img
              :src="`${post.cover}`"
              :alt="post.imageAltText ?? post.title"
              width="516"
              height="382"
            />
          </NuxtLink>
          <div class="play-icon">
            <font-awesome :icon="['fas', 'circle-play']" size="2xl" />
          </div>
        </div>

        <div class="card-body d-flex flex-column align-items-start">
          <h5 class="card-title">{{ post.title }}</h5>
          <NuxtLink :to="{name: 'language-modelos-name-making-of', params: {name: post.slug}}" class="button--more">
            {{ translate.shootModel }}
            <font-awesome
              :icon="['fas', 'arrow-right']"
              size="sm"
              style="margin-left: 8px"
            />
          </NuxtLink>
        </div>
      </div>
    </Slide>

    <template #addons>
      <Pagination />
    </template>
  </Carousel>
</template>

<script lang="ts" setup>
import { Carousel, Slide, Pagination } from "vue3-carousel";
import modelsTradutor from "@/tradutors/makingof";
import "vue3-carousel/dist/carousel.css";

const storeLocale = localeStore();
defineProps({
  posts: {
    type: Array<any>,
    required: true,
  },
});

const route = useRoute();

const translate = computed(() =>
  (route.params.language) == "pt-br"
    ? modelsTradutor.portugues
    : modelsTradutor.ingles
);

const settings = {
  itemsToShow: 1.03,
  snapAlign: "center",
  breakpointMode: "carousel",
  breakpoints: {
    // 700px and up
    700: {
      itemsToShow: 2.5,
      snapAlign: "center",
    },
    // 1024 and up
    1024: {
      itemsToShow: 2.5,
      snapAlign: "start",
    },
  },
};
</script>
<style scoped>
.card-title {
  height: 28px;
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: 18px;
}

.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #5b5858;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.small svg {
  margin-right: 5px;
}

.img-box {
  position: relative;
  width: 100%;
}

.img-box img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.card {
  background-color: #fff;
  padding-right: 24px;
}

.card-body {
  padding: 0px;
}

:deep(.carousel__pagination-button::after) {
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  opacity: 0.2;
  background-color: #000000;
  margin-right: 15px;
}

:deep(.carousel__pagination-button) {
  background-color: unset;
  top: 4px;
}

:deep(.carousel__pagination-button--active) {
  background-color: #000000;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 15px;
  top: 2px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .card {
    padding-right: 12px;
  }
}
</style>
